/**
 *  All api related to beauty assistant session
 */

import _ from 'lodash'
import { CancelToken } from 'axios'
import { OmnitechApi } from '../../api'
import { cancelRequest } from '../../helpers'
import { isErrorExist, convertResponseToErrorObject } from '../../omnitech-error'

export function fetchBeautyAssistantSession(options) {
  const { id, ...others } = options
  const params = {
    // schemaVersion: '2019-08-22',
    ...others
  }
  const source = CancelToken.source()
  cancelRequest.add(
    'fetchBeautyAssistantSession',
    () => source.cancel('fetchBeautyAssistantSession: Operation cancelled by user')
  )

  return OmnitechApi
    .request({
      endpoint: `beauty_assistant_sessions/${id}`,
      method: 'get',
      params,
      cancelToken: source.token
    })
    .catch(error => {
      if (cancelRequest.isCancel(error)) {
        throw cancelRequest.getErrorObject()
      }
      throw convertResponseToErrorObject(_.get(error, 'response.data'), { useResponseMessage: true })
    })
    .then(response => {
      if (isErrorExist(response.data)) throw convertResponseToErrorObject(response.data, { useResponseMessage: true })
      return response.data
    })
    .then(({ data }) => ({
      beautyAssistantSession: data.beautyAssistantSession
    }))
}

export function fetchBeautyAssistantSessionBySlugName(options) {
  const { slug, ...params } = options
  const source = CancelToken.source()
  cancelRequest.add(
    'fetchBeautyAssistantSessionBySlugName',
    () => source.cancel('fetchBeautyAssistantSessionBySlugName: Operation cancelled by user')
  )

  return OmnitechApi
    .request({
      endpoint: `beauty_assistant_sessions/by_slug_name/${slug}`,
      method: 'get',
      params,
      cancelToken: source.token
    })
    .catch(error => {
      if (cancelRequest.isCancel(error)) {
        throw cancelRequest.getErrorObject()
      }
      throw convertResponseToErrorObject(_.get(error, 'response.data'), { useResponseMessage: true })
    })
    .then(response => {
      if (isErrorExist(response.data)) throw convertResponseToErrorObject(response.data, { useResponseMessage: true })
      return response.data
    })
    .then(({ data }) => ({
      beautyAssistantSession: data.beautyAssistantSession
    }))
}
